/* global google */

import { useEffect, useMemo } from 'react';
import { useMap, useMapsLibrary } from '@vis.gl/react-google-maps';

const Heatmap = ({ reports, radius, opacity }) => {
  const map = useMap();
  const visualization = useMapsLibrary('visualization');

  // Custom gradient
  const gradient = [
    'rgba(0, 255, 255, 0)', // No reports at this location
    'rgba(0, 255, 255, 1)', // 1 report with a single location
    'rgba(0, 191, 255, 1)', // 2 reports with a single location
    'rgba(0, 127, 255, 1)', // 3 reports with a single location
    'rgba(0, 63, 255, 1)', // etc ...
    'rgba(0, 0, 255, 1)',
    'rgba(0, 0, 223, 1)',
    'rgba(0, 0, 191, 1)',
    'rgba(0, 0, 159, 1)',
    'rgba(0, 0, 127, 1)',
    'rgba(63, 0, 91, 1)',
    'rgba(127, 0, 63, 1)',
    'rgba(191, 0, 31, 1)',
    'rgba(255, 0, 0, 1)',
  ];

  const heatmap = useMemo(() => {
    if (!visualization) return null;

    return new google.maps.visualization.HeatmapLayer({
      radius,
      opacity,
    });
  }, [visualization, radius, opacity]);

  useEffect(() => {
    if (!heatmap) return;

    heatmap.setData(
      reports.map((report) => {
        const { lng, lat } = report;

        return {
          location: new google.maps.LatLng(lat, lng),
          //   weight: 1, // Used if we want to show some locations as a higher weight
        };
      })
    );

    // heatmap.set('gradient', gradient);
  }, [heatmap, reports, radius, opacity, gradient]);

  useEffect(() => {
    if (!heatmap) return;

    heatmap.setMap(map);

    // eslint-disable-next-line consistent-return
    return () => {
      heatmap.setMap(null);
    };
  }, [heatmap, map]);

  return null;
};

export default Heatmap;
